import * as _ from 'lodash';
import router from '../../router';
import { createNewUserFromFirebaseAuthUser } from '../../misc/helpers';
import UsersDB from '../../firebase/users-db';
import CitiesDB from '../../firebase/cities-db';
import ProvidersDB from '../../firebase/property-providers-db';
import PropertyTypes from '../../firebase/property-types-db';
import ContactDB from '../../firebase/contact-db';
import SubDB from '../../firebase/property-email-subscriptions-db';

export default {
  /**
   * Callback fired when user login
   */
  login: async ({ commit, dispatch }: any, firebaseAuthUser: { uid: any; providerData?: any }) => {
    const userFromFirebase = await new UsersDB().read(firebaseAuthUser.uid);

    const user = _.isNil(userFromFirebase)
      ? await createNewUserFromFirebaseAuthUser(firebaseAuthUser)
      : userFromFirebase;

    commit('setUser', user);
    dispatch('products/getUserProducts', null, { root: true });
  },

  /**
   * Callback fired when user logout
   */
  logout: ({ commit }: any) => {
    commit('setUser', null);
    commit('products/setProducts', null, { root: true });

    const currentRouter = router.app.$route;
    if (!(currentRouter.meta && currentRouter.meta.authNotRequired)) {
      router.push('/login');
    }
  },

  getSelectedSubcat: async ({ commit, rootState }: any) => {
    const subCatagoriesDB = new PropertyTypes(rootState.search.mainCatSelected.name);
    const subcatinfo = await subCatagoriesDB.readAll([['name', '==', rootState.search.subCatSelected.name]]);
    commit('subCatInfo', subcatinfo);
  },

  sendMessage: async ({ commit }: any, msg: any) => {
    commit('sentMsg', false);
    const email = new ContactDB();
    await email.create(msg);
    commit('sentMsg', true);
  },

  subscribe: async ({ commit }: any, subInfo: any) => {
    const sub = new SubDB();
    commit('sentMsg', false);
    await sub.create(subInfo);
    commit('sentMsg', true);
  },

  getTestKitProducts: async ({ commit, rootState }: any) => {
    console.log(rootState.search.MainOptionSelected);
    console.log(rootState.search.SelectedOption);
    const testkits = new ProvidersDB(rootState.search.mainCatSelected.name, rootState.search.subCatSelected.name);
    const getkits = await testkits.getCards(rootState.search.mainCatSelected.name, rootState.search.subCatSelected.name);
    console.log(getkits);
    commit('setKits', getkits);
  },

  getLatest: async ({ commit, rootState }: any) => {
    // const userProductDb = new UserProductsDB('1')
    console.log(rootState.search.MainOptionSelected);
    console.log(rootState.search.SelectedOption);
    console.log('rootState.search.SelectedOption');
    const testkits = new ProvidersDB('Vancouver', 'Houses');
    const getkits = await testkits.getLatestCards('Vancouver', 'Houses');
    console.log(getkits);
    const arr: any[] = [];
    getkits.forEach((value: any) => {
      value.forEach((element: any) => {
        arr.push(element);
      });
    });
    const sortedArr = _.sortBy(arr, [function (o) { return o.id; }]);
    const latestArr = sortedArr.slice(0, 3);
    console.log(latestArr);
    commit('setUpdateKits', latestArr);
  },

  getMainOptions: async ({ commit }: any) => {
    console.log('searchOptions');
    const testkitdb = new CitiesDB();
    const searchOptions = await testkitdb.getSubCatagories();
    console.log('searchOptions');
    console.log(searchOptions);
    commit('setMainOptions', searchOptions);
  },

};
